
import workWithUs from './WorkWithUsReducer';

export default workWithUs;
